import { useState, useEffect } from 'react'

export const useFetchAllClients = ({marvarApi, dispatch, onLogout}) => {

    // 1. Para los datos recuperados de la BD
    const [dataClients, setDataClients] = useState([])
    
    // 2. Para mostrar animación de carga
    const [ loadingFetchClients, setLoadingFetchClients ] = useState(false)

    // 3. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            
            const response = await marvarApi.get(`/legal-notarial/fetch-all-clients`)
            // console.log('[useFetchData][useFetchAllClients] response.data ', response.data)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        setLoadingFetchClients(true)
        fetchData()
            .then((resp) => {
                setDataClients(resp.rows)
                setLoadingFetchClients(false)
            })
            .catch(e => {
                console.log(e, '________ERROR')
                setLoadingFetchClients(false)
            })
    }, [execute])

    return { dataClients, loadingFetchClients, executeFetch }

}

export const useFetchProcessType = ({marvarApi, dispatch, onLogout}) => {

    // 1. Para los datos recuperados de la BD
    const [dataProcessType, setDataProcessType] = useState([])
    
    // 2. Para mostrar animación de carga
    const [ loadingFetchProcessType, setLoadingFetchProcessType ] = useState(false)

    // 3. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            
            const response = await marvarApi.get(`/legal-notarial/fetch-process-type-for-process-lawyer`)
            // console.log('[useFetchData][useFetchProcessType] response.data ', response.data)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        setLoadingFetchProcessType(true)
        fetchData()
            .then((resp) => {
                setDataProcessType(resp.rows)
                setLoadingFetchProcessType(false)
            })
            .catch(e => {
                console.log(e, '________ERROR')
                setLoadingFetchProcessType(false)
            })
    }, [execute])

    return { dataProcessType, loadingFetchProcessType, executeFetch }

}

export const useFetchAllProcessLawyer = ({marvarApi, dispatch, onLogout}) => {

    // 1. Para los datos recuperados de la BD
    const [dataProcessLawyer, setDataProcessLawyer] = useState([])
    
    // 2. Para mostrar animación de carga
    const [ loadingFetchProcessLawyer, setLoadingFetchProcessLawyer ] = useState(false)

    // 3. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            
            const response = await marvarApi.get(`/legal-notarial/fetch-all-process-lawyer/0`)
            console.log('[useFetchData][useFetchAllProcessLawyer] response.data ', response.data)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        setLoadingFetchProcessLawyer(true)
        fetchData()
            .then((resp) => {
                setDataProcessLawyer(resp.rows)
                setLoadingFetchProcessLawyer(false)
            })
            .catch(e => {
                console.log(e, '________ERROR')
                setLoadingFetchProcessLawyer(false)
            })
    }, [execute])

    return { dataProcessLawyer, loadingFetchProcessLawyer, executeFetch }

}

export const useFetchSpecificProcessLawyer = ({marvarApi, dispatch, onLogout, Forms}) => {

    // 1. Para los datos recuperados de la BD
    // const [infoClient, setInfoClient] = useState([])
    const { FormScreen } = Forms
    const { formState, setFormState } = FormScreen
    
    // 2. Para mostrar animación de carga
    const [ loadingFetchSpecificProcessLawyer, setLoadingFetchSpecificProcessLawyer ] = useState(false)

    // 3. Para setear parametros de búsqueda al fetch
    const [paramsToSearch, setParamsToSearch] = useState({idlawyer: ''})

    // 4. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        try {
            
            const response = await marvarApi.get(`/legal-notarial/fetch-specific-process-lawyer/${paramsToSearch.idlawyer}`)
            console.log('[useFetchData][useFetchSpecificProcessLawyer] response.data ', response.data)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if(paramsToSearch.idlawyer > 0 ){
            setLoadingFetchSpecificProcessLawyer(true)
            fetchData()
                .then((resp) => {
                    
                    // Setea en el estado del formulario los datos del registro
                    const { rows } = resp
                    setFormState((prevState) => ({
                        ...prevState,
                        idlawyer: rows[0].idlawyer || '',
                        idprocesstype: rows[0].idprocesstype || '',
                        idcliente: rows[0].idcliente || '',
                        date_start: rows[0].date_start || '',
                        initial_amount: rows[0].initial_amount || '',
                        initial_amount_mask: parseFloat(rows[0].initial_amount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })  || '',
                        process_number: rows[0].process_number || '',
                        observations: rows[0].observations || '',
                        flag_paid: rows[0].flag_paid || '',
                        date_paid: rows[0].date_paid || '',
                        process_ministry: rows[0].process_ministry || ''
                    }))
                    setLoadingFetchSpecificProcessLawyer(false)

                })
                .catch(e => {
                    console.log(e, '________ERROR')
                    setLoadingFetchSpecificProcessLawyer(false)
                })
        }
    }, [execute])

    return { loadingFetchSpecificProcessLawyer, setParamsToSearch, executeFetch }

}

export const useFetchAllExpenses = ({marvarApi, dispatch, onLogout}) => {

    const [ paramsToSearch, setParamsToSearch ] = useState({
        idlawyer: ''
    })

    const [dataExpenses, setDataExpenses] = useState([])
    
    // 2. Para mostrar animación de carga
    const [ loadingFetchAllExpenses, setLoadingFetchAllExpenses ] = useState(false)

    // 3. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            
            const response = await marvarApi.get(`/legal-notarial/fetch-all-expenses/${paramsToSearch.idlawyer}`)
            // console.log('[useFetchData][useFetchAllExpenseReception] response.data ', response.data)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if(paramsToSearch.idlawyer !== '' ){
            setLoadingFetchAllExpenses(true)
            fetchData()
                .then((resp) => {
                    setDataExpenses(resp.rows)
                    setLoadingFetchAllExpenses(false)
                })
                .catch(e => {
                    console.log(e, '________ERROR')
                    setLoadingFetchAllExpenses(false)
                })
        }
    }, [execute])

    return { dataExpenses, loadingFetchAllExpenses, executeFetch, setParamsToSearch }

}

export const useFetchSpecificExpense = ({marvarApi, dispatch, onLogout, Forms}) => {

    // 1. Para los datos recuperados de la BD
    // const [infoClient, setInfoClient] = useState([])
    const { FormOtherExpense } = Forms
    const { formState, setFormState } = FormOtherExpense
    
    // 2. Para mostrar animación de carga
    const [ loadingFetchSpecificExpense, setLoadingFetchSpecificExpense ] = useState(false)

    // 3. Para setear parametros de búsqueda al fetch
    const [paramsToSearch, setParamsToSearch] = useState({idlawyerexpense: ''})

    // 4. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        try {
            
            const response = await marvarApi.get(`/legal-notarial/fetch-specific-expense/${paramsToSearch.idlawyerexpense}`)
            console.log('[useFetchData][useFetchSpecificExpense] response.data ', response.data)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if(paramsToSearch.idlawyerexpense > 0 ){
            setLoadingFetchSpecificExpense(true)
            fetchData()
                .then((resp) => {
                    
                    // Setea en el estado del formulario los datos del registro
                    const { rows } = resp
                    setFormState((prevState) => ({
                        ...prevState,
                        idlawyerexpense: rows[0].idlawyerexpense,
                        idlawyer: rows[0].idlawyer,
                        idexpense: rows[0].idexpense,
                        amount: rows[0].amount,
                        observation: rows[0].observation
                    }))
                    setLoadingFetchSpecificExpense(false)

                })
                .catch(e => {
                    console.log(e, '________ERROR')
                    setLoadingFetchSpecificExpense(false)
                })
        }
    }, [execute])

    return { loadingFetchSpecificExpense, setParamsToSearch, executeFetch }

}

export const useFetchOtherExpenses = ({marvarApi, dispatch, onLogout}) => {

    // 1. Para los datos recuperados de la BD
    const [dataOtherExpenses, setDataOtherExpenses] = useState([])
    
    // 2. Para mostrar animación de carga
    const [ loadingFetchOtherExpenses, setLoadingFetchOtherExpenses ] = useState(false)

    // 3. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            
            const response = await marvarApi.get(`/legal-notarial/fetch-other-expenses`)
            // console.log('[useFetchData][useFetchOtherExpenses] response.data ', response.data)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        setLoadingFetchOtherExpenses(true)
        fetchData()
            .then((resp) => {
                setDataOtherExpenses(resp.rows)
                setLoadingFetchOtherExpenses(false)
            })
            .catch(e => {
                console.log(e, '________ERROR')
                setLoadingFetchOtherExpenses(false)
            })
    }, [execute])

    return { dataOtherExpenses, loadingFetchOtherExpenses, executeFetch }

}

export const useFetchAllLogs = ({marvarApi, dispatch, onLogout}) => {

    const [ paramsToSearch, setParamsToSearch ] = useState({
        idlawyer: ''
    })

    const [ dataLogs, setDataLogs ] = useState([])
    
    // 2. Para mostrar animación de carga
    const [ loadingFetchLogs, setLoadingFetchLogs ] = useState(false)

    // 3. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            
            const response = await marvarApi.get(`/legal-notarial/fetch-all-logs/${paramsToSearch.idlawyer}`)
            console.log('[useFetchData][useFetchAllLogs] response.data ', response.data)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if(paramsToSearch.idlawyer !== '' ){
            setLoadingFetchLogs(true)
            fetchData()
                .then((resp) => {
                    setDataLogs(resp.rows)
                    setLoadingFetchLogs(false)
                })
                .catch(e => {
                    console.log(e, '________ERROR')
                    setLoadingFetchLogs(false)
                })
        }
    }, [execute])

    return { dataLogs, loadingFetchLogs, executeFetch, setParamsToSearch }

}